class ProductYmal extends HTMLElement {
  constructor() {
    super()

    this.sectionId = this.getAttribute('data-section-id')
    this.carousel = null

    this.initSwiper()
  }

  initSwiper () {
    this.carousel = new Swiper(`[data-swiper="${this.sectionId}"]`, {
      breakpoints: {
        990: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 32,
        }
      },
      slidesPerView: 1.5,
      spaceBetween: 32,
    })
  }
}

if (!customElements.get('product-ymal')) {
  customElements.define('product-ymal', ProductYmal)
}